import { useContext } from 'react';
import { Fab, Zoom } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { usePermission } from '../../lib/usePermission';
import { PermissionRequirement } from '../../lib/permissions';
import {
    COPILOT_LAUNCHER_OFFSET,
    COPILOT_LAUNCHER_SIZE,
    isCopilotEnabled,
} from '../../lib/copilot';
import { AppContext } from '../AppContext';
type SttButtonFabProps = {
    onClick: () => void;
    /** Permiso v8 que hace falta para ver el botón. Sin él, se ve siempre. */
    permission?: PermissionRequirement;
};

/**
 * Geometría del botón, exportada porque el widget de tawk se coloca justo
 * encima y necesita saber cuánto sitio ocupa. Alto por defecto de un `Fab`
 * de MUI en tamaño `large`.
 */
export const FAB_BOTTOM = 30;
export const FAB_RIGHT = 30;
export const FAB_SIZE = 56;

/** Hueco entre el botón y el timón de Copilot, el mismo que deja tawk. */
const FAB_GAP = 14;

/**
 * Con Copilot, su timón ocupa la esquina: el botón se pone a su izquierda, en
 * la misma fila, y tawk sigue encima de los dos.
 */
export function fabPosition(copilotOn: boolean): {
    bottom: number;
    right: number;
} {
    if (!copilotOn) return { bottom: FAB_BOTTOM, right: FAB_RIGHT };

    return {
        bottom: COPILOT_LAUNCHER_OFFSET,
        right: COPILOT_LAUNCHER_OFFSET + COPILOT_LAUNCHER_SIZE + FAB_GAP,
    };
}

/**
 * Fab button
 *
 * Button in the corner to make the default operation on the page
 */
export function SttButtonFab({ onClick, permission }: SttButtonFabProps) {
    const { can } = usePermission();
    const cxt = useContext(AppContext);
    const position = fabPosition(isCopilotEnabled(cxt?.sc));

    if (permission && !can(permission)) return null;

    return (
        <Zoom in timeout={400} unmountOnExit>
            <Fab
                id="fab-add-button"
                color="primary"
                onClick={onClick}
                style={{ position: 'fixed', ...position }}
            >
                {/* Sin `color` propio: el icono hereda la tinta que
                    src/styles/GlobalCSS.tsx da a `.MuiFab-primary`
                    (`primary.contrastText`). En blanco se quedaba en 1,3:1
                    sobre el lima. */}
                <AddIcon />
            </Fab>
        </Zoom>
    );
}
